import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import settings from "../../settings.js";
import { Link } from "react-router-dom";

class Contract extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false, data: [] };
  }

  createMarkup(txt) {
    return { __html: txt };
  }
  render() {
    const contract = this.props.contract;

    let cls = "notification";

    if (this.props.openNotification) {
      cls += " withModal";
    }
    return (
      <Link
        to={{
          pathname: "/contracten",
          state: { filterCategory: contract.vc_category },
        }}
        className="">
        <div className={cls} key={contract.contractId}>
          <div className="notificationTitle">{contract.vc_category}</div>
        </div>
      </Link>
    );
  }
}

export default Contract;
